
export default {
  name: 'GrilleDeLiens',
  props: {
    liens: {
      type: Array,
      required: true,
      validator: function (liens) {
        for (const lien of liens) {
          if (!(lien.icone && lien.icone.length > 0)) {
            return false
          }
          if (!(lien.titre && lien.titre.length > 0)) {
            return false
          }
          if (!(lien.url && lien.url.length > 0)) {
            return false
          }
        }
        return true
      }
    }
  }
}
